import { BrowserCacheLocation, Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    redirectUri: window.location.origin,
    authority: process.env.REACT_APP_AUTHORITY,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    windowHashTimeout: 9000, // Applies just to popup calls - In milliseconds
    iframeHashTimeout: 9000, // Applies just to silent calls - In milliseconds
    loadFrameTimeout: 9000, // Applies to both silent and popup calls - In milliseconds
    loggerOptions: {
      piiLoggingEnabled: true,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
